<template>
    <v-container>
        <template v-if="user?.is_subscribed || user?.is_admin || $page.props.free_use">
            <v-row>
                <v-col>
                    <v-select v-model="meetId" :items="clubMeets" label="Select a Meet" solo />
                </v-col>
            </v-row>

            <v-row v-if="meetId && (meet?.concluded || true)" class="medal-totals">
                <!-- Medal summary for mobile - Always visible at the top -->
                <v-col cols="12" class="d-block d-sm-none pb-0">
                    <v-card class="mb-2">
                        <v-card-title class="text-subtitle-1 font-weight-bold py-2"> Meet Medal Summary </v-card-title>
                        <v-card-text class="pt-0 pb-2">
                            <div class="d-flex justify-space-around">
                                <div v-for="placement in 3" :key="`total-medal-${placement}`" class="text-center">
                                    <v-avatar :color="medalColor(placement)" size="40" class="mb-1">
                                        <span class="white--text font-weight-bold">{{
                                            totalAllMedals(placement)
                                        }}</span>
                                    </v-avatar>
                                    <div class="caption font-weight-bold text-uppercase">
                                        {{ medalLabel(placement) }}
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col
                    v-if="trampolineResults.length > 0"
                    :cols="12"
                    :sm="columnWidth"
                    :md="columnWidth"
                    :lg="columnWidth"
                    class="pb-0"
                >
                    <v-card class="mb-4">
                        <v-card-title class="text-subtitle-1 font-weight-bold pb-0">
                            <template v-if="$vuetify.breakpoint.smAndUp">Trampoline Total</template>
                            <template v-else>TRA Total</template>
                        </v-card-title>
                        <v-card-text class="pt-0">
                            <div class="d-flex flex-row justify-space-around">
                                <div
                                    v-for="placement in 3"
                                    :key="`trampoline-total-${placement}`"
                                    class="text-center py-2"
                                >
                                    <v-avatar :color="medalColor(placement)" size="36" class="mb-1">
                                        <span class="white--text font-weight-bold">
                                            <template v-if="$vuetify.breakpoint.smAndUp">{{ placement }}</template>
                                            <template v-else>{{ totalMedals(trampolineResults, placement) }}</template>
                                        </span>
                                    </v-avatar>
                                    <div
                                        v-if="$vuetify.breakpoint.smAndUp"
                                        class="text-subtitle-1 font-weight-bold medal-count"
                                    >
                                        {{ totalMedals(trampolineResults, placement) }}
                                    </div>
                                    <div v-else class="caption font-weight-bold text-uppercase">
                                        {{ medalLabel(placement) }}
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    v-if="doubleMiniResults.length > 0"
                    :cols="12"
                    :sm="columnWidth"
                    :md="columnWidth"
                    :lg="columnWidth"
                    class="pb-0"
                >
                    <v-card class="mb-4">
                        <v-card-title class="text-subtitle-1 font-weight-bold pb-0">
                            <template v-if="$vuetify.breakpoint.smAndUp">Double Mini Total</template>
                            <template v-else>DMT Total</template>
                        </v-card-title>
                        <v-card-text class="pt-0">
                            <div class="d-flex flex-row justify-space-around">
                                <div
                                    v-for="placement in 3"
                                    :key="`double-mini-total-${placement}`"
                                    class="text-center py-2"
                                >
                                    <v-avatar :color="medalColor(placement)" size="36" class="mb-1">
                                        <span class="white--text font-weight-bold">
                                            <template v-if="$vuetify.breakpoint.smAndUp">{{ placement }}</template>
                                            <template v-else>{{ totalMedals(doubleMiniResults, placement) }}</template>
                                        </span>
                                    </v-avatar>
                                    <div
                                        v-if="$vuetify.breakpoint.smAndUp"
                                        class="text-subtitle-1 font-weight-bold medal-count"
                                    >
                                        {{ totalMedals(doubleMiniResults, placement) }}
                                    </div>
                                    <div v-else class="caption font-weight-bold text-uppercase">
                                        {{ medalLabel(placement) }}
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    v-if="tumblingResults.length > 0"
                    :cols="12"
                    :sm="columnWidth"
                    :md="columnWidth"
                    :lg="columnWidth"
                    class="pb-0"
                >
                    <v-card class="mb-4">
                        <v-card-title class="text-subtitle-1 font-weight-bold pb-0">
                            <template v-if="$vuetify.breakpoint.smAndUp">Tumbling Total</template>
                            <template v-else>TUM Total</template>
                        </v-card-title>
                        <v-card-text class="pt-0">
                            <div class="d-flex flex-row justify-space-around">
                                <div
                                    v-for="placement in 3"
                                    :key="`tumbling-total-${placement}`"
                                    class="text-center py-2"
                                >
                                    <v-avatar :color="medalColor(placement)" size="36" class="mb-1">
                                        <span class="white--text font-weight-bold">
                                            <template v-if="$vuetify.breakpoint.smAndUp">{{ placement }}</template>
                                            <template v-else>{{ totalMedals(tumblingResults, placement) }}</template>
                                        </span>
                                    </v-avatar>
                                    <div
                                        v-if="$vuetify.breakpoint.smAndUp"
                                        class="text-subtitle-1 font-weight-bold medal-count"
                                    >
                                        {{ totalMedals(tumblingResults, placement) }}
                                    </div>
                                    <div v-else class="caption font-weight-bold text-uppercase">
                                        {{ medalLabel(placement) }}
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    v-if="synchroResults.length > 0"
                    :cols="12"
                    :sm="columnWidth"
                    :md="columnWidth"
                    :lg="columnWidth"
                    class="pb-0"
                >
                    <v-card class="mb-4">
                        <v-card-title class="text-subtitle-1 font-weight-bold pb-0">
                            <template v-if="$vuetify.breakpoint.smAndUp">Synchro Total</template>
                            <template v-else>SYN Total</template>
                        </v-card-title>
                        <v-card-text class="pt-0">
                            <div class="d-flex flex-row justify-space-around">
                                <div
                                    v-for="placement in 3"
                                    :key="`synchro-total-${placement}`"
                                    class="text-center py-2"
                                >
                                    <v-avatar :color="medalColor(placement)" size="36" class="mb-1">
                                        <span class="white--text font-weight-bold">
                                            <template v-if="$vuetify.breakpoint.smAndUp">{{ placement }}</template>
                                            <template v-else>{{ totalMedals(synchroResults, placement) }}</template>
                                        </span>
                                    </v-avatar>
                                    <div
                                        v-if="$vuetify.breakpoint.smAndUp"
                                        class="text-subtitle-1 font-weight-bold medal-count"
                                    >
                                        {{ totalMedals(synchroResults, placement) }}
                                    </div>
                                    <div v-else class="caption font-weight-bold text-uppercase">
                                        {{ medalLabel(placement) }}
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="$vuetify.breakpoint.smAndUp">
                <v-col v-if="trampolineResults.length > 0" :cols="columnWidth * 2" :md="columnWidth" :lg="columnWidth">
                    <v-list>
                        <v-subheader> Trampoline</v-subheader>
                        <v-list-item v-for="result in trampolineResults" :key="`trampoline-${result.id}`">
                            <v-list-item-icon>
                                <v-avatar :color="result.medal_color">
                                    <span
                                        class="font-weight-bold text-h6"
                                        :class="{
                                            'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                result.medal_color,
                                            ),
                                        }"
                                    >
                                        <inertia-link
                                            :href="`/result-categories/${result.category_id}`"
                                            :style="textColor(result)"
                                        >
                                            {{ result.overall_placement }}
                                        </inertia-link>
                                    </span>
                                </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <inertia-link :href="`/athletes/${result.athlete_id}`">
                                        {{ result.athlete?.name }}
                                    </inertia-link>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                    <br />
                                    Out of {{ result.category.athlete_count }}
                                    <template v-if="result.category.athlete_count === 1">athlete</template>
                                    <template v-else>athletes</template>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>

                <v-col v-if="doubleMiniResults.length > 0" :cols="columnWidth * 2" :md="columnWidth" :lg="columnWidth">
                    <v-list>
                        <v-subheader> Double Mini</v-subheader>
                        <v-list-item v-for="result in doubleMiniResults" :key="`double-mini-${result.id}`">
                            <v-list-item-icon>
                                <v-avatar :color="result.medal_color">
                                    <span
                                        class="font-weight-bold text-h6"
                                        :class="{
                                            'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                result.medal_color,
                                            ),
                                        }"
                                    >
                                        <inertia-link
                                            :href="`/result-categories/${result.category_id}`"
                                            :style="textColor(result)"
                                        >
                                            {{ result.overall_placement }}
                                        </inertia-link>
                                    </span>
                                </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <inertia-link :href="`/athletes/${result.athlete_id}`">
                                        {{ result.athlete?.name }}
                                    </inertia-link>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                    <br />
                                    Out of {{ result.category.athlete_count }}
                                    <template v-if="result.category.athlete_count === 1">athlete</template>
                                    <template v-else>athletes</template>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>

                <v-col v-if="tumblingResults.length > 0" :cols="columnWidth * 2" :md="columnWidth" :lg="columnWidth">
                    <v-list>
                        <v-subheader> Tumbling</v-subheader>
                        <v-list-item v-for="result in tumblingResults" :key="`tumbling-${result.id}`">
                            <v-list-item-icon>
                                <v-avatar :color="result.medal_color">
                                    <span
                                        class="font-weight-bold text-h6"
                                        :class="{
                                            'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                result.medal_color,
                                            ),
                                        }"
                                    >
                                        <inertia-link
                                            :href="`/result-categories/${result.category_id}`"
                                            :style="textColor(result)"
                                        >
                                            {{ result.overall_placement }}
                                        </inertia-link>
                                    </span>
                                </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <inertia-link :href="`/athletes/${result.athlete_id}`">
                                        {{ result.athlete?.name }}
                                    </inertia-link>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                    <br />
                                    Out of {{ result.category.athlete_count }}
                                    <template v-if="result.category.athlete_count === 1">athlete</template>
                                    <template v-else>athletes</template>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>

                <v-col v-if="synchroResults.length > 0" :cols="columnWidth * 2" :md="columnWidth" :lg="columnWidth">
                    <v-list>
                        <v-subheader> Synchro</v-subheader>
                        <v-list-item v-for="result in synchroResults" :key="`synchro-${result.id}`">
                            <v-list-item-icon>
                                <v-avatar :color="result.medal_color">
                                    <span
                                        class="font-weight-bold text-h6"
                                        :class="{
                                            'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                result.medal_color,
                                            ),
                                        }"
                                    >
                                        <inertia-link
                                            :href="`/result-categories/${result.category_id}`"
                                            :style="textColor(result)"
                                        >
                                            {{ result.overall_placement }}
                                        </inertia-link>
                                    </span>
                                </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <inertia-link :href="`/athletes/${result.athlete_id}`">
                                        {{ result.athlete?.name }}
                                    </inertia-link>
                                    <span class="font-weight-bold"> & </span>
                                    <inertia-link :href="`/athletes/${result.athlete_2_id}`">
                                        {{ result.athlete2?.name }}
                                    </inertia-link>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                    <br />
                                    Out of {{ result.category.athlete_count }}
                                    <template v-if="result.category.athlete_count === 1">pair</template>
                                    <template v-else>pairs</template>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>

            <v-row v-else>
                <v-col cols="12" v-if="trampolineResults.length > 0">
                    <v-card>
                        <v-card-title class="primary--text">Trampoline</v-card-title>
                        <v-card-text class="pa-0">
                            <v-list>
                                <v-list-item
                                    v-for="result in trampolineResults"
                                    :key="`trampoline-${result.id}`"
                                    class="py-2"
                                >
                                    <v-list-item-avatar>
                                        <v-avatar :color="result.medal_color" size="36">
                                            <span
                                                class="font-weight-bold"
                                                :class="{
                                                    'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                        result.medal_color,
                                                    ),
                                                }"
                                            >
                                                <inertia-link
                                                    :href="`/result-categories/${result.category_id}`"
                                                    :style="textColor(result)"
                                                >
                                                    {{ result.overall_placement }}
                                                </inertia-link>
                                            </span>
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-medium">
                                            <inertia-link :href="`/athletes/${result.athlete_id}`">
                                                {{ result.athlete?.name }}
                                            </inertia-link>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <small>
                                                {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                                <br />
                                                <span class="grey--text text--darken-1">
                                                    Out of {{ result.category.athlete_count }}
                                                    <template v-if="result.category.athlete_count === 1"
                                                        >athlete</template
                                                    >
                                                    <template v-else>athletes</template>
                                                </span>
                                            </small>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" v-if="doubleMiniResults.length > 0">
                    <v-card>
                        <v-card-title class="primary--text">Double Mini</v-card-title>
                        <v-card-text class="pa-0">
                            <v-list>
                                <v-list-item
                                    v-for="result in doubleMiniResults"
                                    :key="`double-mini-${result.id}`"
                                    class="py-2"
                                >
                                    <v-list-item-avatar>
                                        <v-avatar :color="result.medal_color" size="36">
                                            <span
                                                class="font-weight-bold"
                                                :class="{
                                                    'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                        result.medal_color,
                                                    ),
                                                }"
                                            >
                                                <inertia-link
                                                    :href="`/result-categories/${result.category_id}`"
                                                    :style="textColor(result)"
                                                >
                                                    {{ result.overall_placement }}
                                                </inertia-link>
                                            </span>
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-medium">
                                            <inertia-link :href="`/athletes/${result.athlete_id}`">
                                                {{ result.athlete?.name }}
                                            </inertia-link>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <small>
                                                {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                                <br />
                                                <span class="grey--text text--darken-1">
                                                    Out of {{ result.category.athlete_count }}
                                                    <template v-if="result.category.athlete_count === 1"
                                                        >athlete</template
                                                    >
                                                    <template v-else>athletes</template>
                                                </span>
                                            </small>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" v-if="tumblingResults.length > 0">
                    <v-card>
                        <v-card-title class="primary--text">Tumbling</v-card-title>
                        <v-card-text class="pa-0">
                            <v-list>
                                <v-list-item
                                    v-for="result in tumblingResults"
                                    :key="`tumbling-${result.id}`"
                                    class="py-2"
                                >
                                    <v-list-item-avatar>
                                        <v-avatar :color="result.medal_color" size="36">
                                            <span
                                                class="font-weight-bold"
                                                :class="{
                                                    'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                        result.medal_color,
                                                    ),
                                                }"
                                            >
                                                <inertia-link
                                                    :href="`/result-categories/${result.category_id}`"
                                                    :style="textColor(result)"
                                                >
                                                    {{ result.overall_placement }}
                                                </inertia-link>
                                            </span>
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-medium">
                                            <inertia-link :href="`/athletes/${result.athlete_id}`">
                                                {{ result.athlete?.name }}
                                            </inertia-link>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <small>
                                                {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                                <br />
                                                <span class="grey--text text--darken-1">
                                                    Out of {{ result.category.athlete_count }}
                                                    <template v-if="result.category.athlete_count === 1"
                                                        >athlete</template
                                                    >
                                                    <template v-else>athletes</template>
                                                </span>
                                            </small>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" v-if="synchroResults.length > 0">
                    <v-card>
                        <v-card-title class="primary--text">Synchro</v-card-title>
                        <v-card-text class="pa-0">
                            <v-list>
                                <v-list-item
                                    v-for="result in synchroResults"
                                    :key="`synchro-${result.id}`"
                                    class="py-2"
                                >
                                    <v-list-item-avatar>
                                        <v-avatar :color="result.medal_color" size="36">
                                            <span
                                                class="font-weight-bold"
                                                :class="{
                                                    'white--text': ['yellow darken-2', 'grey', 'brown'].includes(
                                                        result.medal_color,
                                                    ),
                                                }"
                                            >
                                                <inertia-link
                                                    :href="`/result-categories/${result.category_id}`"
                                                    :style="textColor(result)"
                                                >
                                                    {{ result.overall_placement }}
                                                </inertia-link>
                                            </span>
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-medium">
                                            <inertia-link :href="`/athletes/${result.athlete_id}`">
                                                {{ result.athlete?.name }}
                                            </inertia-link>
                                            <span class="font-weight-bold"> & </span>
                                            <inertia-link :href="`/athletes/${result.athlete_2_id}`">
                                                {{ result.athlete2?.name }}
                                            </inertia-link>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <small>
                                                {{ result.category?.description({ without: ['event', 'gender'] }) }}
                                                <br />
                                                <span class="grey--text text--darken-1">
                                                    Out of {{ result.category.athlete_count }}
                                                    <template v-if="result.category.athlete_count === 1">pair</template>
                                                    <template v-else>pairs</template>
                                                </span>
                                            </small>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <template v-else>
            <subscription-required />
        </template>
    </v-container>
</template>

<script>
import get from 'lodash/get.js';
import Meet from '@/Models/Meet.js';
import Result from '@/Models/Result.js';
import User from '@/Models/User.js';
import SubscriptionRequired from '@/Components/SubscriptionRequired.vue';

const rankSort = (a, b) => {
    if (a.overall_rank === b.overall_rank) {
        return a.athlete.name.localeCompare(b.athlete.name);
    }

    return a.overall_rank - b.overall_rank;
};

export default {
    name: 'ClubResults',

    components: { SubscriptionRequired },

    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },

    data: () => ({
        meetId: null,
    }),

    computed: {
        user() {
            return User.find(this.$page.props.auth.user?.id);
        },

        clubMeets() {
            return Meet.query()
                .whereIdIn(_.map(this.$page.props.meets, 'id'))
                .get()
                .map((meet) => ({
                    text: meet.title,
                    value: meet.id,
                }));
        },

        trampolineResults() {
            return this.eventResults('TI').sort(rankSort);
        },

        doubleMiniResults() {
            return this.eventResults('DM').sort(rankSort);
        },

        tumblingResults() {
            return this.eventResults('TU').sort(rankSort);
        },

        synchroResults() {
            return this.eventResults('TS').sort(rankSort);
        },

        meet() {
            if (!this.meetId) {
                return null;
            }

            return Meet.find(this.meetId);
        },

        columnWidth() {
            const competedEvents = [
                this.trampolineResults.length,
                this.doubleMiniResults.length,
                this.tumblingResults.length,
                this.synchroResults.length,
            ];

            if (_.isEmpty(competedEvents)) {
                return 12;
            }

            return 12 / _.filter(competedEvents).length;
        },
    },

    created() {
        if (this.clubMeets.length > 0) {
            this.meetId = _.get(
                Meet.query().whereIdIn(_.map(this.$page.props.meets, 'id')).orderBy('start_date', 'desc').first(),
                'id',
            );
        }
    },

    methods: {
        get,

        eventResults(event, sort = 'overall_rank', sortDirection = 'asc') {
            const results = Result.query()
                .with(['athlete', 'athlete2', 'category'])
                .where('meet_id', this.meetId)
                .where('event', event)
                .where((result) => result.club_id === this.clubId || result.club_2_id === this.clubId)
                .get();

            return _.orderBy(results, [sort, sortDirection]);
        },

        totalMedals(results, placement) {
            return results.filter(
                (result) =>
                    result.overall_placement === String(placement) ||
                    result.overall_placement === `${placement}T` ||
                    result.overall_placement === `${placement}F`,
            ).length;
        },

        totalAllMedals(placement) {
            // Calculate total medals across all events
            return (
                this.totalMedals(this.trampolineResults, placement) +
                this.totalMedals(this.doubleMiniResults, placement) +
                this.totalMedals(this.tumblingResults, placement) +
                this.totalMedals(this.synchroResults, placement)
            );
        },

        medalColor(placement) {
            return Result.medalColor(placement);
        },

        textColor(result) {
            return ['yellow darken-2', 'grey', 'brown'].includes(result.medal_color) || this.$vuetify.theme.dark
                ? 'color: #fff !important'
                : 'color: #000 !important';
        },

        medalLabel(placement) {
            const labels = {
                1: 'Gold',
                2: 'Silver',
                3: 'Bronze',
            };
            return labels[placement] || '';
        },
    },
};
</script>

<style scoped>
/* Mobile optimization styles */
@media (max-width: 600px) {
    .medal-totals .v-card {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) !important;
    }

    .v-list-item {
        padding: 8px 16px;
    }

    .v-list-item__title {
        font-size: 0.95rem;
        line-height: 1.4;
    }

    .v-list-item__subtitle {
        font-size: 0.8rem;
        line-height: 1.3;
    }

    .medal-count {
        font-size: 1.25rem !important;
        font-weight: 700 !important;
    }
}
</style>
